<template>
  <div class="menu-tree" :class="{ tiny: collapsed }">
    <div class="head-logo">
      <img class="logo-img" src="./logo.png" alt="" />
      <span class="title">开源情报数据采集系统</span>
    </div>
    <div class="menu-container">
      <a-menu
        :style="{ width: '100%', flex: 1 }"
        :inlineIndent="16"
        theme="dark"
        @click="handleMenuItenClick"
        :selectedKeys="selectedKeys"
        :openKeys.sync="openKeys"
        mode="inline"
      >
        <a-menu-item key="Dashboard">
          <a-icon type="dashboard" />
          <span>首页</span>
        </a-menu-item>
        <!-- <a-menu-item key="online-search">
          <a-icon type="search" />
          <span>在线搜索</span>
        </a-menu-item> -->
        <template v-for="item in menus">
          <a-menu-item v-if="!item.children" :key="item.meta.title">
            <a-icon :type="item.meta.icon" />
            <span>{{ item.meta.title }}</span>
          </a-menu-item>
          <sub-menu v-else :menu-info="item" />
        </template>
      </a-menu>
    </div>
    <!--    <div class="action">-->
    <!--      <a-icon-->
    <!--        class="trigger"-->
    <!--        :type="collapsed ? 'menu-unfold' : 'menu-fold'"-->
    <!--        @click="onCollapsedChange"-->
    <!--      />-->
    <!--    </div>-->
  </div>
</template>
<script>
import SubMenu from './SubMenu'
import { mapState } from 'vuex'
export default {
  name: 'MenuTree',
  props: {
    collapsed: Boolean
    // onCollapsedChange: Function
  },
  data() {
    return {
      selectedKeys: [],
      openKeys: [],
      openKeysStorage: []
    }
  },
  computed: {
    ...mapState({
      menus: (state) => state.menus
    })
  },
  methods: {
    handleMenuItenClick({ key }) {
      if (key != this.$route.name) {
        this.$router.push({ name: key })
      }
    }
  },
  components: {
    SubMenu
  },
  watch: {
    collapsed() {
      if (this.collapsed) {
        this.openKeysStorage = this.openKeys
        this.openKeys = []
      } else {
        this.openKeys = this.openKeysStorage
      }
    },
    $route: {
      handler() {
        this.selectedKeys = [this.$route.name]
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.menu-tree {
  position: fixed;
  left: 0;
  top: 0;
  width: 200px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #001628;

  &.tiny {
    width: 48px;

    .head-logo {
      width: 100%;
      padding-left: 0;
      justify-content: center;

      img {
        width: 24px;
      }

      .title {
        display: none;
      }
    }

    .action {
      padding-left: 0;
      justify-content: center;
    }
  }

  .head-logo {
    width: 100%;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    height: 64px;
    padding-left: 5px;

    .title {
      font-size: 16px;
      color: #eee;
      font-weight: 600;
      margin-left: 5px;
    }
  }

  .menu-container {
    flex: 1;
    overflow: auto;
    scroll-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .action {
    flex-shrink: 0;
    height: 44px;
    display: flex;
    align-items: center;
    padding-left: 20px;
    color: #999;
    font-size: 16px;
  }
}
</style>

<style>
/* 太丑了！ */
.ant-menu-inline-collapsed > .ant-menu-item,
.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,
.ant-menu-inline-collapsed
  > .ant-menu-item-group
  > .ant-menu-item-group-list
  > .ant-menu-submenu
  > .ant-menu-submenu-title,
.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
  transform: translateX(-16px);
}
</style>
